export default __webpack_public_path__ + "9aac0c2bcd40a42449cdcaf6cde066cd.png";